import { ExtraDataRecordLike } from "@thales-dis-dr/drmcl-ts-shared";
import * as _ from "lodash";

export interface FeatureMap {
  Facematch: boolean;
  SaveJWT: boolean;
  TimeLine: boolean;
}

export interface ConnectionParameters {
  jwt: string | null;
  ipaddress: string;
  id: string;
  key: string;
  port: string | null;
  serial?: string | null;
  model?: string | null;
}

export interface EventData {
  id: number;
  anevent: string;
  time: string;
  isError?: boolean;
  visible?: boolean;
}

export class ExtraDataGroupModel {
  title = "Default";
  key = "";
  items: ExtraDataModel[] = [];
  groups: ExtraDataGroupModel[] = [];

  constructor(object: Partial<ExtraDataGroupModel>) {
    this.title = titleCase(spreadCaps(object?.title || ""));
    this.key = object?.key || "";
  }

  // get_default(): ExtraDataGroupModel {
  //   const def = this.groups.find((x) => x.key === this.key + ".DEFAULT");
  //   if (def) return def;
  //   return new ExtraDataGroupModel({ title: "", key: this.key + ".DEFAULT" });
  // }

  static DefaultRoot = new ExtraDataGroupModel({ title: "Root", key: "" });

  getGroupByPath(groupKeyPath: string): ExtraDataGroupModel {
    let keyRemainder = null;
    let key = groupKeyPath;

    const sep = groupKeyPath.indexOf(".");
    if (sep >= 0) {
      key = groupKeyPath.substring(0, sep);
      keyRemainder = groupKeyPath.substring(sep + 1);
    }

    let child = this.getGroupByKey(key);
    if (!child) {
      let title = key;
      if (title === "") title = "Default";

      child = new ExtraDataGroupModel({ title, key });
      this.groups.push(child);
    }

    if (keyRemainder) return child.getGroupByPath(keyRemainder);
    else return child;
  }

  getGroupByKey(key: string): ExtraDataGroupModel | undefined | null {
    return this.groups.find((x) => x.key == key);
  }

  insert_item(m: ExtraDataModel): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let group: ExtraDataGroupModel = this;
    if (m.key.indexOf(".") >= 0) {
      const sep = m.key.lastIndexOf(".");
      const groupKey = m.key.substring(0, sep);
      group = this.getGroupByPath(groupKey);
    } /* else {
      group = this.get_group("");
    }*/

    group.items.push(m);
  }

  static create_root(records: ExtraDataRecordLike[]): ExtraDataGroupModel {
    const root = new ExtraDataGroupModel({ title: "Root", key: "" });
    if (records && records.length > 0) {
      let readonly = false;
      if (records.filter((x) => x.key.startsWith("meta/")).length > 0) {
        readonly = true;
        records = records.filter((x) => x.key.startsWith("meta/"));
        for (const item of records) {
          item.key = item.key.replace("meta/", "");
        }
      }
      records = records.sort((a, b) => a.key.localeCompare(b.key));
      // TODO:  allow editable
      //readonly = true;

      _.forEach(records, (x) => {
        const m = new ExtraDataModel(x.key, x.value, readonly);
        root.insert_item(m);
      });
    }

    return root;
  }
}
export class ExtraDataModel {
  title: string;
  key: string;
  value: string;

  valueEditor: string;
  private _readonly: boolean;
  clearable = true;
  min = 0;
  max = 6000;
  get readonly(): boolean {
    return this._readonly;
  }
  set readonly(v: boolean) {
    this._readonly = v;
  }
  constructor(key: string, value: string, readonly?: boolean) {
    this.key = key;
    this.value = value;
    this.title = titleCase(spreadCaps(_.last(this.key.split(".")) || key));

    this._readonly = readonly == true;

    this.valueEditor = "TextEditor";
    if (ExtraDataModel.boolKeys.find((x) => x == key)) {
      this.valueEditor = "BoolEditor";
    } else if (ExtraDataModel.hiddenKeys.find((x) => x == key)) {
      this.valueEditor = "PasswordEditor";
    } else if (ExtraDataModel.numberKeys.find((x) => x == key)) {
      this.valueEditor = "NumberEditor";
    } else {
      if (ExtraDataModel.notClearableKeys.find((x) => x == key)) {
        this.clearable = false;
      }
    }
  }
  static notClearableKeys = ["Hostname"];
  static boolKeys = [
    "UseHttp",
    "UseCertChain",
    "ESF.push.captureEnabled",
    "Metrics.enable",
    "ESF.mqtt.enable",
  ];
  static hiddenKeys = ["Acuant.Password", "ESF.mqtt.password"];
  static numberKeys = ["ESF.mqtt.metricIntervalSec"];
}

export function spreadCaps(arg0: string): string {
  return arg0.replace(/([A-Z]+)/g, " $1").trim();
}

export function titleCase(arg0: string): string {
  return arg0
    .toLowerCase()
    .split(" ")
    .map((x) => {
      return x.at(0)?.toUpperCase() + x.slice(1);
    })
    .join(" ")
    .trim();
}
